// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding: 0px;
}

:host(app-landing-page) {
  max-height: 100vh !important;
  height: 100vh !important;
  max-width: 100vw !important;
  width: 100vw !important;
  overflow-y: hidden;
  overflow-x: hidden;
}

::ng-deep .cdk-overlay-pane {
  max-height: 100vh !important;
  height: 100vh !important;
  max-width: 100vw !important;
  width: 100vw !important;
}

::ng-deep .mat-mdc-dialog-container {
  border-radius: 0px !important;
  padding: 0px;
}

.module {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.accept-button {
  width: 3%;
  padding-left: 10px;
}

* {
  box-sizing: border-box !important;
}

html {
  scroll-behavior: smooth;
}

body {
  color: #666666;
  font-size: 14px;
  font-family: "poppins", sans-serif;
  line-height: 1.80857;
  font-weight: normal;
  overflow-x: hidden;
}

a {
  color: #1f1f1f;
  text-decoration: none !important;
  outline: none !important;
  transition: all 0.3s ease-in-out;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  letter-spacing: 0;
  font-weight: normal;
  position: relative;
  padding: 0 0 10px 0;
  font-weight: normal;
  line-height: normal;
  color: #111111;
  margin: 0;
}

h1 {
  font-size: 24px;
}

h2 {
  font-size: 22px;
}

h3 {
  font-size: 18px;
}

h4 {
  font-size: 16px;
}

h5 {
  font-size: 14px;
}

h6 {
  font-size: 13px;
}

*,
*::after,
*::before {
  box-sizing: border-box;
}

h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a {
  color: #212121;
  text-decoration: none !important;
  opacity: 1;
}

button:focus {
  outline: none;
}

ul,
li,
ol {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

p {
  margin: 0px;
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
}

a {
  color: #222222;
  text-decoration: none;
  outline: none !important;
}

a,
.btn {
  text-decoration: none !important;
  outline: none !important;
  transition: all 0.3s ease-in-out;
}

img {
  max-width: 100%;
  height: auto;
}

:focus {
  outline: 0;
}

.btn-custom {
  margin-top: 20px;
  background-color: transparent !important;
  border: 2px solid #ddd;
  padding: 12px 40px;
  font-size: 16px;
}

.lead {
  font-size: 18px;
  line-height: 30px;
  color: #767676;
  margin: 0;
  padding: 0;
}

.form-control:focus {
  border-color: #ffffff !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
}

.navbar-form input {
  border: none !important;
}

.badge {
  font-weight: 500;
}

blockquote {
  margin: 20px 0 20px;
  padding: 30px;
}

button {
  border: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.full {
  float: left;
  width: 100%;
}

.layout_padding {
  padding-top: 90px;
  padding-bottom: 90px;
}

.layout_padding_2 {
  padding-top: 75px;
  padding-bottom: 75px;
}

.light_silver {
  background: #f9f9f9;
}

.theme_bg {
  background: #38c8a8;
}

.margin_top_30 {
  margin-top: 30px !important;
}

.full {
  width: 100%;
  float: left;
  margin: 0;
  padding: 0;
}

/**-- heading section --**/
.main_heading {
  text-align: center;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 50px;
}

.main_heading h2 {
  padding: 0;
  font-size: 48px;
  line-height: 60px;
  font-weight: 400;
  position: relative;
  letter-spacing: -0.5px;
  color: #114c7d;
  border-left: solid #38c8a8 10px;
  padding-left: 15px;
}

.main_heading h2 strong {
  background: #38c8a8;
  color: #fff;
  font-weight: 600;
  padding: 0 15px;
  line-height: 68px;
}

.white_heading_main h2 {
  color: #fff;
}

.small_main_heading {
  margin-top: 25px;
  float: left;
  width: 100%;
  border-bottom: solid rgba(0, 0, 0, 0.07) 1px;
  margin-bottom: 25px;
}

.small_main_heading h2 {
  padding: 2px 0 20px 0;
  color: #114c7d;
  font-weight: 400;
  font-size: 28px;
  background-repeat: no-repeat;
  padding-left: 55px;
  letter-spacing: -0.5px;
}

.small_main_heading h2 strong {
  color: #38c8a8;
  font-weight: 600;
}

.main_bt {
  background: #000;
  color: #fff;
  padding: 10px 60px 10px 60px;
  float: left;
  font-size: 15px;
  font-weight: 400;
  border: solid #000 5px;
  border-radius: 0;
  margin-right: 30px;
}

a.readmore_bt {
  color: #fff;
  font-weight: 300;
  text-decoration: underline !important;
}

.main_bt:hover,
.main_bt:focus {
  background: #ad2101;
  border: solid #ad2101 5px;
  color: #fff;
}

/**-- list icon --**/
.ul_list_info_icon ul {
  list-style: none;
}

.ul_list_info_icon ul li {
  display: inline;
  float: left;
  width: 100%;
}

.ul_list_info_icon ul li img {
  width: 75px;
}

/*----------------------------
    preloader area
----------------------------*/
.loader_bg {
  position: fixed;
  z-index: 9999999;
  background: #fff;
  width: 100%;
  height: 100%;
}

.loader {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader img {
  width: 280px;
}

/*----------------------------
    scroll to top area
----------------------------*/
.scrollup {
  float: right;
  position: absolute;
  color: #fff;
  right: 20px;
  padding: 0px 5px;
  text-transform: uppercase;
  font-weight: 600;
  background: #38c8a8;
  position: fixed;
  bottom: 20px;
  z-index: 99;
  text-align: center;
  color: #fff;
  cursor: pointer;
  border-radius: 0px;
  opacity: 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: scale(1);
  -moz-transform: scale(1);
  -o-transform: scale(1);
  -webkit-transform: scale(1);
  transition: 0.2s all ease;
  -moz-transition: 0.2s all ease;
  -o-transition: 0.2s all ease;
  -webkit-transition: 0.2s all ease;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  line-height: 48px;
  font-size: 16px;
}

.scrollup.b-show_scrollBut {
  opacity: 1;
  visibility: visible;
}

.top_awro {
  background: #ee4a79 none repeat scroll 0 0;
  cursor: pointer;
  padding: 6px 8px;
  position: fixed;
  bottom: 59px;
  right: 20px;
  display: none;
  height: 45px;
  width: 45px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  transition: all 0.5s ease;
}

.sale_pro {
  background: #f25252 !important;
}

.margin_top_50 {
  margin-top: 50px;
}

.margin_bottom_30_all {
  margin-bottom: 30px;
}

.text_align_center {
  text-align: center;
}

/*---------------------------------------------------------------------
    header area
---------------------------------------------------------------------*/
.logo_section {
  text-align: center;
}

.logo {
  float: left;
}

nav.main-menu {
  float: right;
  margin-left: 0;
  margin-top: 20px;
}

.menu-area-main li:hover a,
.menu-area-main li:focus a {
  color: #000;
}

.menu-area-main li.active a {
  color: #000;
}

.right_cart_section {
  float: right;
  width: auto;
}

.right_cart_section ul {
  float: left;
  min-height: auto;
  margin: 0;
  padding: 12px 0 0;
}

.right_cart_section .cart_icons {
  padding: 18px 0 0;
}

.main-menu ul > li nth:child(5) a {
  padding-right: 0px;
}

.right_cart_section ul li {
  float: left;
  font-size: 17px;
  font-weight: 400;
  color: #fff;
  margin-right: 30px;
}

.right_cart_section ul.cart_update li {
  font-size: 13px;
  color: #ccc;
  line-height: normal;
  margin: 0;
  font-weight: 300;
}

.right_cart_section ul.cart_update li span {
  font-size: 18px;
  font-weight: 300;
  color: #fff;
  line-height: 21px;
}

.right_cart_section ul li i {
  margin-right: 10px;
  margin-top: 5px;
  float: left;
  color: #fff;
  font-size: 21px;
}

.right_cart_section ul li a {
  color: #fff;
}

.loginregisterbtn {
  background-color: #055C8D;
  border: solid;
  border-radius: 10px;
  border-color: #055C8D;
  color: white !important;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

/*-- end header middle --*/
.top-bar-info {
  background: #111111;
  padding: 5px 0px;
}

.top-menu-left {
  float: left;
}

.top-menu-left li {
  position: relative;
  display: inline-block;
  margin-right: 11px;
  padding-right: 12px;
}

.top-menu-left li::before {
  content: "";
  position: absolute;
  right: 0;
  top: 9px;
  height: 10px;
  border-right: 1px dotted #999;
}

.top-menu-left li:last-child::before {
  display: none;
}

.top-menu-left li:last-child {
  padding: 0px;
  margin: 0px;
}

.top-menu-left li a {
  color: #ffffff;
  font-size: 12px;
  text-transform: uppercase;
  text-decoration: none;
}

.top-menu-left li a:hover {
  color: #38c8a8;
}

.right-dropdown-language {
  float: right;
  margin-left: 12px;
}

.dropdown-bar .dropdown-link {
  position: absolute;
  z-index: 1009;
  top: 40px;
  left: 0;
  right: auto;
  min-width: 50px;
  padding: 15px;
  background: #ffffff;
  list-style: none;
  border: 2px solid #38c8a8;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: opacity 0.2s ease 0s, visibility 0.2s linear 0s;
  text-align: left;
}

.dropdown-bar:hover .dropdown-link {
  opacity: 1;
  visibility: visible;
  top: 25px;
}

.dropdown-bar.right-dropdown-language > a::after {
  font-family: "FontAwesome";
  content: "\\f107";
  text-decoration: none;
  padding-left: 4px;
  color: #ffffff;
}

.right-dropdown-language > a {
  line-height: 10px;
  padding: 5px 5px;
  cursor: pointer;
}

.dropdown-bar .dropdown-link li a {
  color: #111111;
  display: block;
  font-size: 12px;
  line-height: 15px;
  padding: 5px 0;
}

.dropdown-bar .dropdown-link li a:hover {
  color: #38c8a8;
}

.dropdown-bar .dropdown-link li a img {
  margin-right: 7px;
}

.dropdown-bar .dropdown-link li.active {
  font-weight: bold;
}

.right-dropdown-language .dropdown-link {
  min-width: 100px;
  padding: 7px 10px;
  color: #111111;
}

.dropdown-bar {
  position: relative;
  padding: 0 5px;
  font-size: 13px;
}

.dropdown-bar .dropdown-link.right-sd {
  left: auto;
  right: 0;
}

.right-dropdown-currency {
  float: right;
  margin-left: 12px;
}

.dropdown-bar.right-dropdown-currency > a::after {
  font-family: "FontAwesome";
  content: "\\f107";
  text-decoration: none;
  padding-left: 4px;
  color: #ffffff;
}

.right-dropdown-currency > a {
  line-height: 10px;
  padding: 5px 5px;
  cursor: pointer;
  color: #ffffff;
}

.right-dropdown-currency .dropdown-link {
  min-width: 100px;
  padding: 7px 10px;
  color: #111111;
}

.right-dropdown-currency .dropdown-link {
  min-width: 55px;
  padding: 7px 10px;
}

.right-dropdown-currency .dropdown-link li a span.symbol {
  margin-right: 7px;
}

#login-modal .modal-content {
  border-radius: 0px;
}

#login-modal .modal-content .modal-header {
  background: #38c8a8;
  border-radius: 0;
}

#login-modal .modal-content .modal-body .form-group input {
  background: #ffffff;
  border: 1px solid #c8c8c8;
  border-radius: 0px;
}

#login-modal .modal-content .modal-body .form-group input:focus {
  border: 1px solid #c8c8c8 !important;
}

#login-modal .modal-content form {
  margin-bottom: 10px;
}

.modal-title {
  padding: 0px;
  color: #ffffff;
  font-size: 18px;
  text-transform: uppercase;
}

.btn-template-outlined {
  background: #111111;
  color: #ffffff;
  border: none;
  border-radius: 0px;
}

.btn-template-outlined i {
  padding-right: 10px;
}

.text-muted {
  padding: 10px 0px;
}

.slogan-line {
  float: right;
  color: #ffffff;
  font-size: 13px;
}

.middle-area {
  padding: 30px 0px;
}

.header-search {
  padding: 3px 0px;
}

.header-search form {
  position: relative;
  box-shadow: 0px 1px 10px -1px rgba(0, 0, 0, 0.2);
}

.header-search .btn-group.bootstrap-select {
  position: absolute;
  left: 0px;
  top: 0px;
}

.header-search input {
  width: 100%;
  min-height: 45px;
  border-radius: 0px;
  border: none;
  padding-left: 15px;
  border: 1px solid #e0e7ed;
}

.header-search form .search-btn {
  position: absolute;
  right: 0;
  top: 0;
  border: 0;
  color: #fff;
  font-size: 20px;
  padding: 4px 15px;
  border-radius: 0px;
  background-color: #38c8a8;
  cursor: pointer;
}

.header-search form .search-btn:hover {
  background: #111111;
}

.wish-box {
  float: right;
}

.wish-box a {
  display: inline-block;
}

.wish-box a:hover {
  color: #38c8a8;
}

.wish-box a span.icon {
  background: #38c8a8;
  width: 40px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  position: relative;
  border-radius: 2px;
}

.wish-box a span.icon:hover {
  background: #111111;
}

.cart-content-right {
  padding: 5px 0px;
}

.cart-content-box .items {
  text-align: center;
}

.product-media {
  width: 60px;
  float: left;
  position: relative;
}

.cart-content-box .items:hover .product-media::before {
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
}

.product-media::before {
  position: absolute;
  content: "";
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #38c8a8;
  opacity: 0.4;
  transform: scale(0);
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
}

.cart-content-box .items .item .remove {
  position: absolute;
  right: 0px;
  top: 0px;
  background: #38c8a8;
  color: #ffffff;
  width: 20px;
  height: 20px;
  line-height: 18px;
  border-radius: 2px;
}

.cart-content-box .items .item {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e7ed;
  position: relative;
}

.cart-content-box .items .item .product-info {
  padding-top: 10px;
  padding-left: 71px;
  text-align: left;
}

.cart-content-box .items .item .remove:hover {
  background: #111111;
}

.subtotal {
  text-align: left;
  text-transform: capitalize;
  color: #38c8a8;
  font-weight: 500;
  margin-bottom: 15px;
}

.subtotal span {
  font-weight: bold;
  color: #111111;
  padding-left: 15px;
  float: right;
}

.actions .btn-process {
  padding: 5px 16px;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  border-radius: 2px;
  overflow: hidden;
}

.actions .btn-process:hover {
  color: #ffffff;
}

.line-cart {
  position: relative;
}

.wish-box a span.icon span {
  position: absolute;
  right: -8px;
  top: -8px;
  line-height: initial;
  background: #38c8a8;
  padding: 3px;
  border-radius: 50%;
  width: 17px;
  height: 17px;
  font-size: 12px;
}

.main-menu {
  text-align: center;
}

.main-menu ul {
  margin: 0;
  list-style-type: none;
}

.main-menu ul > li {
  display: inline-block;
  position: relative;
}

.main-menu ul > li a {
  padding: 6px 25px 0 25px;
  line-height: 20px;
  font-size: 17px;
  display: block;
  font-weight: 500;
  color: #055C8D;
}

.main-menu ul li:last-child a {
  padding-right: 0;
}

.sub-down li {
  background: #ffffff;
}

.main-menu ul > li .sub-down li a {
  color: #114c7d;
  font-size: 15px;
  text-transform: capitalize;
  font-weight: 300;
  padding: 12px 5px;
  position: relative;
  border-bottom: solid #eee 1px;
}

.main-menu ul > li .sub-down li a:hover {
  color: #111111;
}

.main-menu ul li:first-child {
  margin-left: 0;
}

.main-menu ul > li > ul {
  opacity: 0;
  position: absolute;
  text-align: left;
  top: 100%;
  transform: scaleY(0);
  transform-origin: 0 0 0;
  transition: all 0.3s ease 0s;
  visibility: hidden;
  width: 240px;
  z-index: 999;
  background: #fff;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}

.main-menu > ul > li:hover > ul {
  transform: scaleY(1);
  visibility: visible;
  opacity: 1;
}

.main-menu ul > li > ul > li {
  margin: 0px;
  position: relative;
  display: block;
}

.main-menu ul > li > ul > li:hover > ul {
  transform: scaleY(1);
  visibility: visible;
  opacity: 1;
  left: 100%;
  top: 10px;
}

.main-menu ul > li > ul > li > a {
  background: none !important;
}

.mean-container .mean-nav {
  margin-top: 0px;
  position: absolute;
  top: 100%;
}

.main-menu ul > li {
  position: inherit;
  display: inline-block;
  vertical-align: middle;
}

.main-menu ul > li:nth-child(6) {
  padding-right: 0px;
}

.nav > li {
  position: inherit;
  display: inline-block;
  vertical-align: middle;
}

.megamenu .sub-down {
  max-width: 1140px;
  width: 100%;
  left: 0;
  margin: 0 auto;
  right: 0;
  padding: 15px 0px;
}

.simple-down {
  padding: 15px;
}

.megamenu-categories {
  padding: 10px 0px;
}

.sub-full.megamenu-categories li {
  display: block;
}

.megamenu .sub-full.megamenu-categories ol li a {
  padding: 5px 0px;
  font-size: 15px !important;
  font-weight: 500;
}

.sub-full.megamenu-categories ol li .category-title {
  padding: 15px 0px;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
}

.sub-full.megamenu-categories ol li .category-box a {
  padding: 5px 0px;
}

.menu-add {
  padding: 30px 15px;
}

.menu-add img {
  width: 100%;
}

.main-w img {
  width: 100%;
}

.women-box {
  position: relative;
}

.women-box::before {
  content: "";
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
}

.banner-up-text {
  position: absolute;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
}

.text-a {
  color: #fff;
  text-transform: uppercase;
  font-size: 40px;
  line-height: 40px;
  font-weight: 700;
}

.text-b {
  color: #fff;
  font-size: 28px;
  text-transform: uppercase;
  line-height: 30px;
  padding: 20px 0px;
}

.text-c {
  color: #ffffff;
  font-size: 31px;
  font-weight: 300;
  text-transform: uppercase;
  line-height: 30px;
  padding-bottom: 20px;
}

.megamenu .sub-full.megamenu-categories .women-box .banner-up-text a {
  background: #111111;
  color: #ffffff !important;
  display: inline-block;
  padding: 10px 16px;
  border-radius: 2px;
  overflow: hidden;
  font-size: 16px;
}

.sticky-wrapper .sticky-wrapper-header {
  z-index: 20 !important;
  background: #ffffff;
}

.is-sticky .sticky-wrapper-header .middle-area {
  padding: 0px 0px;
}

.sticky-wrapper:not(.is-sticky) {
  height: auto !important;
}

.hover-btn {
  display: inline-block;
  vertical-align: middle;
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  background: #111111;
  transition-property: color;
  transition-duration: 0.3s;
}

.hover-btn::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #38c8a8;
  transform: scaleX(0);
  transform-origin: 50%;
  transition-property: transform;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
  display: block !important;
}

.hover-btn:hover::before,
.hover-btn:focus::before,
.hover-btn:active::before {
  transform: scaleX(1);
}

.hover-btn:hover,
.hover-btn:focus,
.hover-btn:active {
  color: white;
  box-shadow: none;
}

.btn-secondary.focus,
.btn-secondary:focus {
  box-shadow: none;
}

.img-responsive {
  max-width: 100%;
}

.padding_right_15_inner {
  padding-right: 15px;
}

.padding_left_15_inner {
  padding-left: 15px;
}

.dark_bg {
  background: #114c7d;
}

/*---------------------------------------------------------------------
    layout new css
---------------------------------------------------------------------*/
.header {
  background: #D2D3D5;
  padding: 10px 0px;
  padding-bottom: 10px;
}

.logo a {
  font-size: 40px;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  line-height: 40px;
}

.relative {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  bottom: 0;
}

.banner-main {
  position: relative;
}

.carousel-caption {
  border-radius: none;
  padding: 2px 2px;
  background: rgba(0, 0, 0, 0.5);
}

.banner-main .carousel-caption h1 {
  color: #fff;
  font-size: 40px;
  line-height: 40px;
  font-weight: bold;
  padding-top: 40px;
}

.banner-main .carousel-caption p {
  font-size: 30px;
  padding: 20px 0px 40px 0px;
}

/** download section **/
.Screenshot {
  padding-top: 60px;
  padding-bottom: 90px;
  background: #fff;
}

.Screenshot .titlepage {
  padding-bottom: 60px;
  text-align: center;
}

.screenshot-title {
  text-align: center;
}

.screenshot-text {
  font-weight: bold;
  padding-bottom: 5px;
}

.Screenshot .titlepage span {
  color: #055C8D;
}

.Screenshot .titlepage h2 {
  padding: 0px 0px 6px 0px;
  font-size: 30px;
  font-weight: bold;
  color: #050303;
  line-height: 46px;
  margin-bottom: 0px;
  margin-bottom: 20px;
  border-bottom: #fc4311 solid 1px;
  width: 242px;
  margin: 0 auto;
  margin-bottom: 0px;
  margin-bottom: 20px;
}

.carousel-item {
  text-align: center;
}

.carousel-control-prev {
  left: inherit;
}

#main_slider .carousel-control-prev,
#main_slider .carousel-control-next {
  width: 55px;
  height: 55px;
  background: #000;
  opacity: 1;
  font-size: 30px;
  color: #fff;
}

#main_slider .carousel-control-prev:hover,
#main_slider .carousel-control-next:hover,
#main_slider .carousel-control-prev:focus,
#main_slider .carousel-control-next:focus {
  background: #055C8D;
  color: #fff;
}

#main_slider a.carousel-control-prev {
  position: absolute;
  top: 40%;
}

#main_slider a.carousel-control-next {
  position: absolute;
  top: 40%;
}

.read-more {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.read-more a {
  background: #000;
  width: 206px;
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  padding: 15px 0px;
  font-weight: 500;
  font-size: 17px;
  line-height: 30px;
  margin-top: -27px;
  transition: ease-in all 0.5s;
}

.read-more a:hover {
  background: #055C8D;
  border-radius: 25px;
  transition: ease-in all 0.5s;
}

/** end download section **/
/** about section **/
.about {
  padding: 60px 0px;
  background: #f4f4f4;
}

.top_layer {
  position: relative;
}

.top_layer::before {
  position: absolute;
  width: 100%;
  height: 50px;
  content: "";
  background-position-x: 0%;
  background-position-y: 0%;
  background-repeat: repeat;
  background-size: auto;
  height: 500px;
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
  top: -180px;
}

.about .titlepage {
  text-align: center;
  padding-bottom: 60px;
}

.about .titlepage h2 {
  padding: 0px 0px 6px 0px;
  font-size: 30px;
  font-weight: bold;
  color: #055C8D;
  line-height: 46px;
  border-bottom: #D2D3D5 solid 1px;
  width: 410px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.about .titlepage span {
  color: #3d3c3c;
  font-size: 14px;
  line-height: 30px;
}

.about .about-box {
  max-width: 530px;
  width: 100%;
  float: right;
  padding: 18px 0;
}

.about .about-box h3 {
  font-size: 36px;
  text-transform: uppercase;
  line-height: 37px;
  padding-bottom: 30px;
}

.about .about-box p {
  font-size: 17px;
  line-height: 28px;
}

.about .about-img figure {
  margin: 0;
}

.about a {
  text-transform: uppercase;
  border: #000 solid 1px;
  background: #000;
  width: 206px;
  padding: 15px 0;
  font-weight: 500;
  font-size: 17px;
  line-height: 30px;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  margin-top: 50px;
  transition: ease-in all 0.5s;
}

.about a:hover {
  border: #055C8D solid 1px;
  background: #055C8D;
  border-radius: 25px;
  transition: ease-in all 0.5s;
}

/** end about section **/
/** blog section **/
.blog {
  background-color: #fff;
  padding: 60px 0px;
}

.blog .titlepage {
  text-align: center;
}

.blog .titlepage h2 {
  padding: 0px 0px 20px 0px;
  font-size: 30px;
  font-weight: bold;
  color: #055C8D;
  line-height: 50px;
  display: inline-block;
  position: relative;
  border-bottom: #D2D3D5 solid 1px;
  margin: 0 auto;
  margin-bottom: 0px;
  margin-bottom: 0px;
  margin-bottom: 20px;
}

.blog .titlepage span {
  color: #0e0f10;
  font-size: 14px;
  line-height: 32px;
  display: inline-block;
  margin-bottom: 0px;
  display: block;
  margin-bottom: none;
}

.blog .blog-box {
  margin-bottom: 30px;
}

.blog .blue h3 {
  background: #fff;
  color: #055C8D;
  font-size: 36px;
  line-height: 100px;
  margin: 10px;
  padding: 2%;
  position: relative;
  text-align: center;
}

.blog .blog-box figure {
  margin: 0px;
}

.blog .blog-box figure span {
  top: 0;
  left: 0px;
  position: absolute;
  margin-left: 15px;
  background: #055C8D;
  padding: 10px 30px;
  color: #fff;
}

.blog .blog-box h3 {
  font-size: 20px;
  padding-top: 10px;
  line-height: 30px;
}

.blog .blog-box p {
  font-size: 14px;
  line-height: 30px;
}

.like {
  color: #055C8D;
}

.Comment {
  color: #055C8D;
}

/** end blog section **/
.width {
  width: 25%;
}

.copyright {
  background-color: #fff;
  padding: 20px 0px;
  margin-top: 55px;
}

.copyright p {
  color: #000;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  font-weight: 400;
}

/*---------------------------------------------------------------------
    ener page css
---------------------------------------------------------------------*/
.about-bg {
  background-color: #ad2100;
  margin-bottom: 90px;
}

.about-bg .abouttitle h2 {
  color: #fff;
  text-transform: uppercase;
  font-size: 40px;
  line-height: 45px;
  padding: 40px 0;
  font-weight: 500;
  text-align: center;
}

.Currency-bg {
  background-color: #ad2100;
}

.Currency-bg .abouttitle h2 {
  color: #fff;
  text-transform: uppercase;
  font-size: 40px;
  line-height: 45px;
  padding: 40px 0;
  font-weight: 500;
  text-align: center;
}

.Request-bg {
  background-color: #ad2100;
}

.Request-bg .abouttitle h2 {
  color: #fff;
  text-transform: uppercase;
  font-size: 40px;
  line-height: 45px;
  padding: 40px 0;
  font-weight: 500;
  text-align: center;
}

.Team-bg {
  background-color: #ad2100;
}

.Team-bg .abouttitle h2 {
  color: #fff;
  text-transform: uppercase;
  font-size: 40px;
  line-height: 45px;
  padding: 40px 0;
  font-weight: 500;
  text-align: center;
}

.container__header {
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 4;
}

.nav__appbar {
  min-height: 1rem;
  padding: 0.65rem 0;
}

.wrapper__header {
  height: 100%;
  z-index: 14;
  align-items: center;
  display: flex;
}

.content__container {
  height: 100%;
  max-width: calc(1440px + 12rem);
}

@media only screen and (min-width: 75rem) {
  .content__container {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}
.content__wrapper {
  width: 100%;
  margin: 0 auto;
  align-items: center;
  display: flex;
}

.section__content {
  display: flex;
  align-items: center;
  height: 100%;
  z-index: 1;
}

.header__list {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  align-items: center;
}

.tab__link {
  color: #055C8D;
}

.tab__link:hover {
  text-decoration: none;
  cursor: pointer;
  color: #055C8D;
}

.desktop__view {
  display: inherit;
}

.header__list li {
  padding-left: 2.375rem;
  list-style-type: none;
}

.section__right {
  justify-content: flex-end;
  flex: 1 1;
}

.btn__medium {
  display: inline-flex;
  justify-content: center;
  font-weight: 500;
  border-radius: 2px;
  padding: 5px;
  font-size: 14px;
  line-height: 1.5;
  min-width: 8rem;
  transition: all 0.1s ease-in-out;
}

.btn_purple {
  color: #fff;
  background-color: #055C8D;
  border-color: transparent;
}

.btn_purple:active, .btn_purple:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  text-decoration: none;
  color: #fff;
}

.btn_purple:active {
  color: #fff;
  background-color: #055C8D;
}

.btn_purple:focus {
  box-shadow: 0 0 0 3px rgba(100, 0, 228, 0.5);
}

.btn_purple.btn_outline__purple {
  color: #055C8D;
  background-color: transparent;
  border: 1px solid #055C8D;
}

.btn_purple.btn_outline__purple:hover {
  background-color: rgba(210, 211, 213, 0.5);
  box-shadow: none;
}

.btn_purple.btn_outline__purple:active {
  background-color: rgba(100, 0, 228, 0.4);
  box-shadow: none;
}

.register__btn {
  padding: 0;
}

.container__main-page {
  max-width: 90rem !important;
  margin: auto;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;
}

@media only screen and (min-width: 48rem) {
  .container__main-page {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
::ng-deep .carousel-control-next,
::ng-deep .carousel-control-prev {
  width: 55px;
  height: 55px;
  background: #000;
  opacity: 1;
  font-size: 30px;
  color: #fff;
  position: absolute;
  top: 40%;
}

::ng-deep .carousel-control-next:hover,
::ng-deep .carousel-control-prev:hover,
::ng-deep .carousel-control-next:focus,
::ng-deep .carousel-control-prev:focus {
  background: #055C8D;
  color: #fff;
  border-radius: 25px;
  opacity: 1;
}

::ng-deep .carousel-control-prev {
  left: inherit;
}

::ng-deep .primary {
  min-width: 132px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
